import React from "react";
import { Routes, Route } from "react-router-dom";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Password from "@/pages/Password";

import Layout from "@/pages/Layout";
import AuthRoute from "@/components/AuthRoute";

// 左侧
import Sheds from '@/pages/Sheds'
import Device from "@/pages/Device";
import Video from "@/pages/Video";
import DeviceSetting from '@/pages/Device/devicessetting'
import Police from "@/pages/Police";
import Devicemanage from "@/pages/Devicemanage";


export default function Router() {
    return (
        <>
            {/* 路由 */}
            <Routes>
                {/* 创建路由path和组件对应关系 */}
                <Route path='/login' element={<Login />}></Route>
                <Route path='/register' element={<Register />}></Route>
                <Route path='/password' element={<Password />}></Route>
                {/* Layout需要做鉴权处理 */}
                {/* 中间页 */}

                {/* <Route path='/center' element={<AuthRoute><Center /></AuthRoute>}></Route> */}
                <Route path='/' element={<AuthRoute><Layout /></AuthRoute>}>
                    <Route index element={<Sheds />}> </Route>
                    <Route path='/device' element={<Device />}></Route>
                    <Route path='/devicessetting' element={<DeviceSetting />}></Route>
                    <Route path='/video' element={<Video />}></Route>
                    <Route path='/sheds' element={<Sheds />}></Route>
            <Route path='/police' element={<Police />}></Route>
            <Route path='/devicemanage' element={<Devicemanage />}></Route>
                </Route>
            </Routes>
        </>
    )
}
